import { Theme } from "./theme.model";

export const THEMES: Theme[] = [
  {
    host: ['default'],
    partialHost: 'default',
    name: 'default',
    icon: 'assets/imgs/sandaya-logo.png',
    favicon: 'assets/favicons/default-favicon.ico',
    title: 'Sandaya',
  },
  {
    host: [
      'localhost',
      'wallet-dev.guestup.com',
      'wallet-test.guestup.com',
      'sandaya.guestup.com',
    ],
    partialHost: 'sandaya',
    name: 'sandaya',
    icon: 'assets/imgs/sandaya-logo.png',
    favicon: 'assets/favicons/sandaya-favicon.ico',
    title: 'Sandaya',
  },
];
